// extracted by mini-css-extract-plugin
export default {"container":"B1-z","heading":"C1-z","links":"D1-z","copy":"E1-z","subCopy":"F1-z","linksLeft":"G1-z","linksCenter":"H1-z","linksRight":"I1-z","link":"J1-z","onlyLink":"K1-z"};